import {
	fetchBranchAreaList,
	fetchBranchListFromAreaName,
	branchNameFromBranchCode,
} from '@/api';

const namespaced = true;

const state = {
	isOpenModal: false,
	branchAreaList: [],
	branchList: [],
	branchName: '',
	isOpenOverlayModal: false,
	overlayContentComp: null,
	overlayModalTitle: '',
};

const getters = {
	isOpenModal(state) {
		return state.isOpenModal;
	},
	branchAreaList(state) {
		return state.branchAreaList;
	},
	branchList(state) {
		return state.branchList;
	},
	branchName(state) {
		return state.branchName;
	},
	isOpenOverlayModal(state) {
		return state.isOpenOverlayModal;
	},
	overlayContentComp(state) {
		return state.overlayContentComp;
	},
	overlayModalTitle(state) {
		return state.overlayModalTitle;
	},
};

const mutations = {
	openModal(state) {
		return (state.isOpenModal = true);
	},
	closeModal(state) {
		state.isOpenModal = false;
	},
	getBranchAreaList(state, { list }) {
		if (list === undefined) return;

		state.branchAreaList = list;
	},
	getBranchListFromAreaName(state, { list }) {
		if (list === undefined) return;

		state.branchList = list;
	},
	initBranchList(state) {
		state.branchList = [];
	},
	setbranchName(state, branchName) {
		state.branchName = branchName;
	},
	openOverlayModal(state) {
		state.isOpenOverlayModal = true;
	},
	closeOverlayModal(state) {
		state.isOpenOverlayModal = false;
	},
	setOverlayContentComp(state, component) {
		state.overlayContentComp = component;
	},
	setOverlayModalTitle(state, title) {
		state.overlayModalTitle = title;
	},
};

const actions = {
	getBranchAreaList({ commit }) {
		return fetchBranchAreaList()
			.then(response => {
				commit('getBranchAreaList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getBranchListFromAreaName({ commit }, payload) {
		return fetchBranchListFromAreaName(payload)
			.then(response => {
				response.data.code === '00000'
					? commit('getBranchListFromAreaName', response.data)
					: commit('initBranchList');
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getbranchNameFromBranchCode({ commit }, payload) {
		return branchNameFromBranchCode(payload)
			.then(response => {
				commit('setbranchName', response.data.mini_company);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	openOverlayModal({ commit }) {
		commit('openOverlayModal');
	},
	closeOverlayModal({ commit }) {
		commit('closeOverlayModal');
	},
	setOverlayContentComp({ commit }, { component }) {
		commit('setOverlayContentComp', component);
	},
	setOverlayModalTitle({ commit }, { title }) {
		commit('setOverlayModalTitle', title);
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
